export const BU_HERO_COLORS = [
  'white',
  'light',
  'dark',
  'black',
  'text',
  'primary',
  'link',
  'info',
  'success',
  'warning',
  'danger'
];

export const BU_HERO_SIZES = [
  'medium',
  'large',
  'fullheight'
];
